<template>
  <div class="grid grid-cols-2 md:grid-cols-5 gap-4">
    <ImageUploader v-for="n in 10" :key="n" :idx="String(n)" :currentVersion="versionMap[n] || '0'"
      :merchantId="currentMerchantId" :baseUrl="baseUrl" :imageUploadApi="imageUploadApiImpl"
      @success="onItemUploadSuccess" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { ImageUploader } from '@myorg/r2-lib'
import { imageUploadApiImpl, menuImageApiImpl } from './imageUploadImpl'

// 加上類型斷言防止 TS 抱怨 null
const currentMerchantId = localStorage.getItem('merchantId')
if (!currentMerchantId) {
      throw new Error('Merchant ID not found in storage')
    }
// 環境變數判斷
const baseUrl = import.meta.env.VITE_UPLOAD_R2_URL

const onItemUploadSuccess = async ({ url, idx }: { url: string, idx: string }) => {
  menuImageApiImpl.confirmUpload(Number(idx))
  // 更新本地版本地圖，觸發 UI 刷新
  // versionMap.value[Number(idx)] = url
  await fetchImageVersions()

}

const isLoading = ref(false)
const versionMap = ref<Record<string, string>>({})

const fetchImageVersions = async () => {
  isLoading.value = true
  try {
    // 1. Tell TS that images is an array of MerchantImageURL
    const images = await menuImageApiImpl.getImages()
    const mapping: Record<string, string> = {}

    // 確保這裡的 k 是字串
    Object.entries(images).forEach(([k, v]) => {
      mapping[String(k)] = String(v)
    })

    versionMap.value = mapping
    Object.entries(versionMap.value).forEach(([k, v]) => {

    })

  } catch (err) {
    console.error('Failed to fetch image versions:', err)
  } finally {
    isLoading.value = false
  }
}

onMounted( async () => {
  await fetchImageVersions()
})
</script>